export enum PaymentCaseEnum {
  Packages = 1,
  CustomCredit = 2,
  Line = 3,
  Proforma = 4,
  Plans = 5,
  Tower = 6,
  Official = 7,
  DedicatedBasePrice = 8,
  SmartZoneSend = 9,
  MessengerSend= 10,
}
